import { api } from './api';

export interface GroupMember {
  _id: string;
  phone: string;
  name: string;
  network: 'mtn' | 'airteltigo' | 'telecel';
}

export interface SavedGroup {
  _id: string;
  name: string;
  emoji: string;
  members: GroupMember[];
  lastUsedAt: string | null;
  useCount: number;
  createdAt: string;
  updatedAt: string;
}

const savedGroupsAPI = {
  getAll: () =>
    api.get<{ success: boolean; groups: SavedGroup[] }>('/saved-groups'),

  create: (payload: { name: string; emoji?: string; members?: Omit<GroupMember, '_id'>[] }) =>
    api.post<{ success: boolean; group: SavedGroup }>('/saved-groups', payload),

  update: (id: string, payload: { name?: string; emoji?: string }) =>
    api.put<{ success: boolean; group: SavedGroup }>(`/saved-groups/${id}`, payload),

  remove: (id: string) =>
    api.delete<{ success: boolean }>(`/saved-groups/${id}`),

  markUsed: (id: string) =>
    api.patch<{ success: boolean }>(`/saved-groups/${id}/use`),

  addMember: (id: string, member: Omit<GroupMember, '_id'>) =>
    api.post<{ success: boolean; group: SavedGroup }>(`/saved-groups/${id}/members`, member),

  removeMember: (groupId: string, memberId: string) =>
    api.delete<{ success: boolean; group: SavedGroup }>(`/saved-groups/${groupId}/members/${memberId}`),
};

export { savedGroupsAPI };
